import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {TruncateTooltipCellComponent} from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import {UtilityService} from "@irb-common/services/utility.service";
import {ComEsSecurityEquivalentsComponent} from "@irb/irb-editors/editor-security/security-equivalents-alternatives/com-es-security-equivalents/com-es-security-equivalents.component";
import {altIfHeldCheckboxCellRenderer} from "@irb/irb-editors/editor-security/renderers/altIfHeldCheckBoxCellRenderer.component";


@Injectable({
    providedIn: "root"
})
export class SecurityEquivalentsGridLayoutService implements GridLayoutService<ComEsSecurityEquivalentsComponent> {
    sizeFor: any;

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "eqSecuritySymbol": 60,
            "eqSecurityDescription": 100,
            "eqSecurityType": 100,
            "altIfHeldSymbol": 100
        };
    }

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "altIfHeldCheckboxCellRenderer":altIfHeldCheckboxCellRenderer
        };
    }

    getColumnDefs(parent: ComEsSecurityEquivalentsComponent) {
        return [
            {
                headerName: "Delete All",
                headerComponent: "DeleteHeaderComponent",
                headerComponentParams: {
                    message: "Remove all equivalents?",
                    note: "",
                    proceed: parent.deleteAll.bind(parent),
                    cancel: parent.cancelDelete.bind(parent)
                },
                cellRenderer: "DeleteCellComponent",
                cellRendererParams: {
                    message: "Remove this equivalent?",
                    note: "",
                    proceed: parent.delete.bind(parent),
                    cancel: parent.cancelDelete.bind(parent)
                },
                resizable: false,
                minWidth: 25,
                maxWidth: 25,
                width: 25,
                suppressColumnsToolPanel: true
            },
            {
                headerName: 'Symbol/Category',
                field: 'eqSecuritySymbol',
                minWidth: this.sizeFor.eqSecuritySymbol,
                flex: 2,
                sort: "asc",
                resizable: false,
                comparator: this.util.sortString.bind(parent),
                suppressMovable: true
            },
            {
                headerName: 'Description',
                field: 'eqSecurityDescription',
                minWidth: this.sizeFor.eqSecurityDescription,
                flex: 3,
                resizable: false,
                comparator: this.util.sortString.bind(parent),
                cellRenderer : "cellRendererFormatter"
            },
            {
                headerName: parent.ENABLE_AS_SECTYPE ? 'Trade Type' : 'Type',
                field: 'eqSecurityType',
                minWidth: this.sizeFor.eqSecurityType,
                flex: 1,
                editable: false,
                resizable: false,
                valueGetter: this.formatSecurityType,
            },
            {
                headerName: "Alt if Held",
                field: "altIfHeldFlag",
                hide: false,
                cellStyle: {'text-align' : 'center'},
                minWidth: this.sizeFor.altIfHeldSymbol,
                flex: 1,
                cellRenderer: "altIfHeldCheckboxCellRenderer"
            }];
    }

    formatSecurityType(params: any)
    {
        switch(params.data.eqSecurityType)
        {
            case "EQUITY":
                return "Equity";
            case "EQ":
                return "Equity";
            case "MUTUAL_FUND":
                return "Mutual Fund";
            case "MF":
                return "Mutual Fund";
            case "CASH":
                return "Cash";
            case "GROUP":
                return "Group";
            case "BOND":
                return "Bond";
            case "OTHER":
                return "Other";
            case "EXTERNAL":
                return "External";
            case "CustCat":
                return "Category";
            case "OPTION":
                return "Option";
            default:
                return params.data.eqSecurityType;
        }
    }
}
